import fetchJSON from '@api/api_helper';

const getUrl = (assetKey) => `/api/v4/assets/${assetKey}/attachments`;

export default (options, updateFetchControllers) => (
  fetchJSON(getUrl(options.assetKey), options, updateFetchControllers)
);
